const FAILED_REASON = {
  ACCESSIBLE_ACCESS_DENIED: "ACCESSIBLE_ACCESS_DENIED",
  GROUPWORK_ACCESSIBLE_ACCESS_DENIED: "GROUPWORK_ACCESSIBLE_ACCESS_DENIED",
  PREREQUISITE_ACCESS_DENIED: "PREREQUISITE_ACCESS_DENIED",
  PARENT_ACCESS_DENIED: "PARENT_ACCESS_DENIED",
  OPEN_TEAM: "OPEN_TEAM",
};

export { FAILED_REASON };
